import { render, staticRenderFns } from "./paises.vue?vue&type=template&id=e2d27214"
import script from "./paises.vue?vue&type=script&lang=js"
export * from "./paises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports